export const firsTransactionsHeader = [
  { label: 'Customer Name', key: 'name' },
  { label: 'Customer Email', key: 'email' },
  { label: 'Product Id', key: 'companyProductID' },
  { label: 'Product Name', key: 'companyProductName' },
  { label: 'Amount', key: 'actualAmount' },
  { label: 'Date Created', key: 'date' },
];
